import { AbstractPageDataProvider, PageDefaults } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { IVideo } from "@/models/video.entity";
import videoService from "@/services/mrfiktiv/services/video.service";
import { MrfiktivPartnerVideoControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const VideoPageDataProvider = new (class extends AbstractPageDataProvider<
  IVideo,
  MrfiktivPartnerVideoControllerGetParamsGen
> {
  itemsPerPage = PageDefaults.DEFAULT_PAGE_SIZES[3];

  async getPage(query: MrfiktivPartnerVideoControllerGetParamsGen): Promise<IPageViewModel<IVideo>> {
    const res = await videoService.getAll(query);

    const meta = res.meta;
    const data = (res.data ?? []) as IVideo[];

    return { meta, data };
  }
})();
